import React from 'react';
import { Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { Button, Touchable } from '../../../../ui';

export type OnboardingSectionProps = {
  onClick: () => void;
  iconContent?: React.ReactNode;
  testID?: string;
  label?: string;
  color?: string;
  borderColor?: string;
  borderStyle?: string;
};

const OnboardingSection: React.FCWithChildren<OnboardingSectionProps> = ({
  onClick,
  iconContent,
  testID = 'onboardingSection',
  label,
  color = colors.whiteWash,
  borderColor = colors.lightGrey,
  borderStyle = 'solid',
}) => (
  <Touchable onClick={onClick} testID={testID}>
    <Inline
      borderColor={borderColor}
      borderStyle={borderStyle}
      borderWidth={1}
      borderRadius={2}
      color={color}
      justifyContent="center"
      alignItems="center"
      padding={20}
      space={4}
      minHeight={85}
    >
      {iconContent}
      {label ? (
        <Inline>
          <Button
            appearance="link-lowercase"
            size="medium"
          >
            {label}
          </Button>
        </Inline>
      ) : null}
    </Inline>
  </Touchable>
);

export default OnboardingSection;
